import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-paragraph',
  templateUrl: './icon-paragraph.component.html',
  styleUrls: ['./icon-paragraph.component.scss'],
})
/**
 * Icon Paragraph Component also has a title!
 */
export class IconParagraphComponent {
  @Input() paragraph?: string;
  @Input() title?: string;
  @Input() icon?: string;
}
